import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Button, message, List, Typography } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { getNotifications, markAsRead, markAllAsRead } from '../../api/notifications';
import { notificationTarget } from '../../utils/notificationTarget';
import useAuthStore from '../../store/authStore';

const { Text } = Typography;

const NotificationsHistoryTab = () => {
  const navigate = useNavigate();
  const { user } = useAuthStore();
  const [notifs, setNotifs]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage]       = useState(1);
  const [total, setTotal]     = useState(0);
  const pageSize = 15;

  const load = (p = page) => {
    setLoading(true);
    getNotifications({ page: p, per_page: pageSize })
      .then(res => {
        setNotifs(res.data.data || []);
        setTotal(res.data.meta?.total || res.data.total || 0);
      })
      .catch(() => message.error('Bildirimler yüklenemedi.'))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(1); }, []);

  const handleOpen = (n) => {
    if (!n.read_at) {
      markAsRead(n.id).catch(() => {});
      setNotifs(prev => prev.map(x => x.id === n.id ? { ...x, read_at: new Date().toISOString() } : x));
    }
    const target = notificationTarget(n, user?.role);
    if (target) navigate(target);
  };

  const handleMarkAllRead = () => {
    markAllAsRead()
      .then(() => setNotifs(prev => prev.map(n => ({ ...n, read_at: n.read_at || new Date().toISOString() }))))
      .catch(() => message.error('İşlem başarısız.'));
  };

  const hasUnread = notifs.some(n => !n.read_at);

  return (
    <Card
      title="Bildirimlerim"
      extra={hasUnread && <Button size="small" onClick={handleMarkAllRead}>Tümünü Okundu İşaretle</Button>}
    >
      <List
        loading={loading}
        dataSource={notifs}
        locale={{ emptyText: 'Henüz bildirim yok.' }}
        pagination={{
          current: page,
          pageSize,
          total,
          onChange: p => { setPage(p); load(p); },
          showTotal: t => `Toplam ${t} bildirim`,
        }}
        renderItem={n => (
          <List.Item onClick={() => handleOpen(n)} style={{ cursor: notificationTarget(n, user?.role) ? 'pointer' : 'default', background: n.read_at ? 'transparent' : '#f0f7ff', padding: '10px 12px', borderRadius: 8 }}>
            <List.Item.Meta
              avatar={<BellOutlined style={{ color: n.read_at ? '#bbb' : '#1677ff', marginTop: 4 }} />}
              title={<span style={{ fontWeight: n.read_at ? 400 : 600 }}>{n.title}</span>}
              description={
                <div>
                  <div>{n.body}</div>
                  <Text type="secondary" style={{ fontSize: 12 }}>
                    {dayjs(n.sent_at || n.created_at).format('DD.MM.YYYY HH:mm')}
                  </Text>
                </div>
              }
            />
          </List.Item>
        )}
      />
    </Card>
  );
};

export default NotificationsHistoryTab;
